import apiClient from '../api/apiClient';

/**
 * Get lookup values for a specific entity type
 * @param {number} orgId - The organization ID
 * @param {string} entityType - The entity type (e.g., 'return_reason', 'tax_percentage')
 * @returns {Promise<Array>} Promise resolving to an array of lookup values
 */
export const getLookupValues = async (orgId, entityType) => {
  try {
    const response = await apiClient.get(`/organizations/lookup/${orgId}/${entityType}`);
    return response.data || [];
  } catch (error) {
    console.error(`Failed to fetch ${entityType} lookup values:`, error);
    return []; // Return empty array on error for graceful degradation
  }
};

/**
 * Create a new lookup value
 * @param {number} orgId - The organization ID
 * @param {string} entityType - The entity type (e.g., 'return_reason', 'tax_percentage')
 * @param {string} value - The value to create
 * @returns {Promise<Object>} Promise resolving to the created lookup entry
 */
export const createLookupValue = async (orgId, entityType, value) => {
  try {
    const response = await apiClient.post('/organizations/lookup', {
      org_id: orgId,
      entity_type: entityType,
      value: value.toString(), // Ensure it's a string
    });
    return response.data;
  } catch (error) {
    // Check if it's a conflict error (value already exists)
    if (error.response && error.response.status === 409) {
      console.log(`Value "${value}" already exists for ${entityType} - skipping`);
      return { value }; // Return the value anyway for client-side consistency
    }
    console.error(`Failed to create ${entityType} lookup value:`, error);
    throw error;
  }
};

/**
 * Delete a lookup value by ID
 * @param {number} id - The lookup entry ID
 * @returns {Promise<void>}
 */
export const deleteLookupValue = async (id) => {
  return apiClient.delete(`/organizations/lookup/${id}`);
};
